import React from "react";
import Header from "~/components/common/Header";
import { type HeaderProps } from "~/components/common/Header";

interface PageContainerProps {
  children: React.ReactNode;
  showHeader?: boolean;
  headerProps?: HeaderProps;
}

export default function PageContainer({
  children,
  showHeader = true,
  headerProps = {
    showAnnouncement: true,
  },
}: PageContainerProps) {
  // Calculate margin-top based on header and announcement visibility
  // Header height is typically 64px (h-16), announcement adds additional height
  const getMarginTop = () => {
    if (!showHeader) return "";
    if (headerProps?.showAnnouncement) return "pt-24"; // More space when announcement is shown
    return "pt-16"; // Just header height
  };

  return (
    <>
      {showHeader && <Header {...headerProps} />}
      <div className={`${getMarginTop()} flex min-h-screen flex-col justify-between bg-[#F8F8F2]`}>{children}</div>
    </>
  );
}
